import { render, staticRenderFns } from "./circle-slice.vue?vue&type=template&id=45baf3fb&scoped=true"
var script = {}
import style0 from "./circle-slice.vue?vue&type=style&index=0&id=45baf3fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45baf3fb",
  null
  
)

export default component.exports